import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class CaixaPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
            buscaPessoa, buscaPlanoCta, buscaSituacao, buscaDescricao, buscaTipoDoc,
            buscaCtaCorrente } = this.props.filtros;

        if ((buscaDataIni) && (buscaDataFim)) {

            let dataIni = '';
            if ((buscaDataIni) && (buscaDataIni !== undefined)) {
                dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }
            let dataFim = '';
            if ((buscaDataFim) && (buscaDataFim !== undefined)) {
                dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }

            axios
                .get('/titulos/listaCaixa', {
                    params: {
                        print: true,
                        controle: buscaControle,
                        numero: buscaNumero,
                        descricao: buscaDescricao,
                        tipo: buscaTipo.key,
                        situacao: buscaSituacao.key,
                        pessoa: buscaPessoa.key,
                        ctaFin: buscaPlanoCta.key,
                        tipoDoc: buscaTipoDoc.key,
                        ctaCorrente: buscaCtaCorrente.key,
                        dataIni,
                        dataFim,
                    }
                })
                .then(response => {
                    const { data } = response;
                    this.setState({
                        listaRegistros: data,
                        carregando: false,
                    });
                })
                .catch(erro => {
                    console.warn(erro);
                    this.setState({
                        carregando: false,
                    });
                });
        } else {
            this.setState({
                listaRegistros: [],
                carregando: false,
            });
        }

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderValorCred = (registro) => {
        if (registro.pc_tipo === 'E') {
            return (
                <span> {numeral(parseFloat(registro.tpp_valor)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderValorDeb = (registro) => {
        if (registro.pc_tipo === 'S') {
            return (
                <span> {numeral(parseFloat(registro.tpp_valor)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderHistorico = (tit_descricao, registro) => {
        return (
          <span>{'[' + registro.pes_nome + '] ' + tit_descricao}</span>
        );
      };
    
    

    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Caixa - Extrato de Conta Corrente
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Período: </span>
                                <span>{this.props.periodo + '       ' + (this.props.situacaoCaixa === 'X' ? 'NÃO CRIADO' : (this.props.situacaoCaixa === 1 ? 'ABERTO' : 'FECHADO'))}</span>

                                {this.props.ctaCorrente ? (
                                    <div>
                                        <span style={{ fontWeight: "bold" }}>Cta Corrente: </span>
                                        <span>{this.props.ctaCorrente.label}</span>
                                    </div>
                                ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 10, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Saldo Inicial: </span>
                                <span>R$ {this.renderValor(this.props.vlrInicial)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Créditos: </span>
                                <span>R$ {this.renderValor(this.props.vlrCred)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Débitos: </span>
                                <span>R$ {this.renderValor(this.props.vlrDeb)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Saldo Final: </span>
                                <span>R$ {this.renderValor(this.props.vlrFinal)}</span>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.tit_idf + '_' + listaRegistros.tparc_parcela)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="tpp_data_pagto"
                                    dataIndex="tpp_data_pagto"
                                    title="Data"
                                    render={this.renderData}
                                    width={90}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pc_abreviatura"
                                    dataIndex="pc_abreviatura"
                                    title="Conta"
                                    width={60}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="td_descricao"
                                    dataIndex="td_descricao"
                                    title="Tipo Documento"
                                    width={100}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_controle"
                                    dataIndex="tit_controle"
                                    title="Controle"
                                    width={60}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_numero"
                                    dataIndex="tit_numero"
                                    title="Número"
                                    width={60}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_descricao"
                                    dataIndex="tit_descricao"
                                    title="Histórico"
                                    width={150}
                                    align="left"
                                    className="listaCadastro"
                                    render={this.renderHistorico}
                                />
                                <Column
                                    key=""
                                    dataIndex=""
                                    title="Crédito"
                                    render={this.renderValorCred}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key=""
                                    dataIndex=""
                                    title="Débito"
                                    render={this.renderValorDeb}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />

                            </Table>
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default CaixaPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/CaixaPrintModal.js